import React from "react";
import styles from "../styles/error-message.module.css";

export type ErrorMessageProps = {
  className?: string;
  title?: string;
  children: React.ReactNode;
};

export default function ErrorMessage({
  className,
  title,
  children,
}: ErrorMessageProps) {
  return (
    <div className={`${className || ""} ${styles.errorMessage}`} lang="en">
      {title && <h1 className={styles.errorMessageTitle}>{title}</h1>}
      <p className={styles.errorMessageText}>{children}</p>
    </div>
  );
}
